import { IsVisibleOnItemGridBaseValueConverter } from 'General/Resources/ValueConverters/IsVisibleOnItemGridBase';
export class IsVisibleOnItemGridValueConverter extends IsVisibleOnItemGridBaseValueConverter {

}